import PlatformLayout from "@/layouts/PlatformLayout";
import AdminDashboard from "@/pages/dashboards/AdminDashboard";

const PlatformDashboardPage = () => {
  return (
    <PlatformLayout activeTab="dashboard">
      <AdminDashboard />
    </PlatformLayout>
  );
};

export default PlatformDashboardPage;
